import { computed, Ref, watch } from "vue";
import { Mate } from "@/types/entity";
import { useHead } from "@unhead/vue";
import { useBrowserLocation } from "@vueuse/core";

export const useMateChatHead = (mate: Ref<Mate | null>) => {
  const location = useBrowserLocation();
  const title = computed(
    () => `${mate.value?.name}, best crushon ai free nsfw ai chat | Anymate`
  );
  const href = computed(() => location.value.href);
  watch(
    mate,
    () => {
      if (!mate.value) return;
      useHead({
        title: title,
        link: [
          {
            rel: "canonical",
            href: href,
          },
        ],
        meta: [
          {
            name: "description",
            content: computed(
              () =>
                `${mate.value?.name} is the best free nsfw ai chat you are going to crushon. Unlike character ai,it can generate nsfw and uncensored content.You have to be over 18 to start an ai chat.`
            ),
          },
          {
            property: "og:title",
            content: title,
          },
          {
            property: "og:description",
            content: computed(
              () =>
                `Meet ${mate.value?.name}, the best crushon ai free nsfw ai chat. Chat with ${mate.value?.name} now!`
            ),
          },
          {
            property: "og:image",
            content: computed(() => mate.value?.mediaUrl),
          },
          {
            property: "og:url",
            content: href,
          },
        ],
      });
    },
    { immediate: true }
  );
};
